import React, { useState } from 'react'
import { IoCalendarOutline, IoPerson } from 'react-icons/io5'
import logo from '../../assets/logo.jpg'
import '../../css/dashboard.css'
import { boxes } from '../../assets/mangoeaList'
import CommndPopup from '../CommndPopup'
import box1 from '../../assets/boxes/carton-fruitibox.png'

const Orders = () => {
    const [ cart, setCart ] = useState([]);
    const [ transport, setTransport ] = useState('bateau');
    const [ isOpen, setIsOpen ] = useState(true);
    const [ boxId, setBoxId ] = useState(1);
    const [ box, setBox ] = useState({
        id: 1,
        img: box1,
        nom: "Fruitibox"
    });

    const closeModal = () => {
        setIsOpen(false);
    }

    const showBox = () => {
        const boxindex = { boxes }.findIndex(b => b.id == boxId);
        setBox({ boxes }[boxindex]);
    }

    const showCommand = command => {
        setCart(command.mangoes);
        setTransport(command.transport);
        setBoxId(command.box);
        showBox();
    }

  return (
    <div className='db'>
    <header>
        <div className="logo"><img src={logo} alt="" /></div>
    </header>

    <section>
        <div className="command">
            <div className="profil"><IoPerson /></div>
            <div className="text">
                <h3>Bassirou Ba</h3>
                <span className="company">SUNU MANGO</span>
                <div className="date">
                    13 janv. <span className="icon"><IoCalendarOutline /></span>
                </div>
            </div>
        </div>
        <div className="command">
            <div className="profil"><IoPerson /></div>
            <div className="text">
                <h3>Bassirou Ba</h3>
                <span className="company">SUNU MANGO</span>
                <div className="date">
                    13 janv. <span className="icon"><IoCalendarOutline /></span>
                </div>
            </div>
        </div>
        <div className="command">
            <div className="profil"><IoPerson /></div>
            <div className="text">
                <h3>Bassirou Ba</h3>
                <span className="company">SUNU MANGO</span>
                <div className="date">
                    13 janv. <span className="icon"><IoCalendarOutline /></span>
                </div>
            </div>
        </div>
        <div className="command">
            <div className="profil"><IoPerson /></div>
            <div className="text">
                <h3>Bassirou Ba</h3>
                <span className="company">SUNU MANGO</span>
                <div className="date">
                    13 janv. <span className="icon"><IoCalendarOutline /></span>
                </div>
            </div>
        </div>
        <div className="command">
            <div className="profil"><IoPerson /></div>
            <div className="text">
                <h3>Bassirou Ba</h3>
                <span className="company">SUNU MANGO</span>
                <div className="date">
                    13 janv. <span className="icon"><IoCalendarOutline /></span>
                </div>
            </div>
        </div>
        <div className="command">
            <div className="profil"><IoPerson /></div>
            <div className="text">
                <h3>Bassirou Ba</h3>
                <span className="company">SUNU MANGO</span>
                <div className="date">
                    13 janv. <span className="icon"><IoCalendarOutline /></span>
                </div>
            </div>
        </div>
    </section>

    <aside>
        {isOpen &&
        <CommndPopup
         cart={cart}
         transport={transport}
         box={box}
         closeModal={closeModal}
        />
        }
    </aside>
    </div>
  )
}

export default Orders